export default {
  'en-GB': {
    currency: {
      style: 'currency', currency: 'USD'
    }
  }
};
